import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta13Model } from './model-consultaSeguimentoPergunta13'

export const convertConsultaSeguimentoPergunta13ToInput = (
  value: ConsultaSeguimentoPergunta13Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_13_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_13_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_13_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_13_ANDA_SEM_APOIO),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
